import { contracts } from '../../data/contracts'

export default {
	name: 'FOOD',
	shortName: 'OFOOD',
	contractAddress: contracts[process.env.REACT_APP_NETWORK].foodAddress,
	url: 'http://lorem.com',
	logo: 'tokens/OFood.png'
}
